<template>
    <div class="transactions-page" :class="{'loading':loadingNow || renderingNow}">
        <div class="row">
          <h3>Transactions</h3>
          <div class="query-search-switcher">
                <span class="switch-label" :class="{'active':!searchSelected}" @click="searchSelected = false">Query</span>
                <label class="toggle-switch-label color-mode-switch">
                  <input type="checkbox" v-model="searchSelected">
                  <span class="switchmark">
                      <span class="switch-check"></span>
                  </span>
                </label>
                <span class="switch-label" :class="{'active':searchSelected}" @click="searchSelected = true">Search</span>
          </div>
          <div 
            v-if="!searchSelected"
            class="refresh" 
            @click="getQueryData(1)">
          </div>
        </div>

        <!-- template for forms -->
        <template v-if="displayForm">
          <!-- form for queries -->
          <form v-if="!searchSelected">
            <div class="activePlaceholderImitation">
              <datepicker
                v-model="query.filters.immediate.startDate"
                calendar-class='calendar'
                :disabled-dates="{from: new Date(query.filters.immediate.endDate)}"
                :use-utc='true'
              ></datepicker>
              <span>Start date</span>
            </div>

            <div class="selectWrapper activePlaceholder" :class="{'selected':query.filters.immediate.blockchain}">
              <v-select v-model="query.filters.immediate.blockchain" :options="blockchainList"></v-select>
              <span>Blockchain</span>
            </div>

            <div class="selectWrapper activePlaceholder" :class="{'selected':query.filters.immediate.direction}">
              <v-select v-model="query.filters.immediate.direction" :options="directionList"></v-select>
              <span>Direction</span>
            </div>

            <div class="activePlaceholder">
              <input type="text" placeholder=" " v-model="query.filters.throttle.from_owner">
              <span>From owner</span>
            </div>
            <div class="activePlaceholder">
              <input type="text" placeholder=" " v-model="query.filters.throttle.to_owner">
              <span>To owner</span>
            </div>
            <div class="activePlaceholder">
              <input type="text" placeholder=" " v-model="query.filters.throttle.from_address">
              <span>From address</span>
            </div>
            <!-- next line -->

            <div class="activePlaceholderImitation">
              <datepicker
                v-model="query.filters.immediate.endDate"
                calendar-class='calendar'
                :disabled-dates="{to: new Date(query.filters.immediate.startDate)}"
                :use-utc='true'
              ></datepicker>
              <span>End date</span>
            </div>

            <div class="selectWrapper activePlaceholder" :class="{'selected':query.filters.immediate.token}">
              <v-select v-model="query.filters.immediate.token" :options="tokenList"></v-select>
              <span>Token</span>
            </div>

            <div class="amount">
              <div class="moreLess">
                <div class="less" :class="{'active':!moreSelected}" @click="moreSelected = false; getQueryData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
                <div class="more" :class="{'active':moreSelected}" @click="moreSelected = true; getQueryData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
              </div>
              <div class="activePlaceholder">
                <input type="number" placeholder=" " v-model="query.filters.throttle.amount_usd">
                <span>Amount USD</span>
              </div>
            </div>

            <div class="selectWrapper activePlaceholder" :class="{'selected':query.filters.immediate.from_owner_type}">
              <v-select v-model="query.filters.immediate.from_owner_type" :options="fromTypeList"></v-select>
              <span>From type</span>
            </div>

            <div class="selectWrapper activePlaceholder" :class="{'selected':query.filters.immediate.to_owner_type}">
              <v-select v-model="query.filters.immediate.to_owner_type" :options="toTypeList"></v-select>
              <span>To type</span>
            </div>

            <div class="activePlaceholder">
              <input type="text" placeholder=" " v-model="query.filters.throttle.to_address">
              <span>To address</span>
            </div>

          </form>
          <!-- form for search -->
          <form v-else class="searchForm">
            <datepicker
              v-model="search.filters.immediate.startDate"
              calendar-class='calendar'
              :disabled-dates="{from: new Date(search.filters.immediate.endDate)}"
              :use-utc='true'
            ></datepicker>
            <datepicker
              v-model="search.filters.immediate.endDate"
              calendar-class='calendar'
              :disabled-dates="{to: new Date(search.filters.immediate.startDate)}"
              :use-utc='true'
            ></datepicker>
            <div class="activePlaceholder">
              <input type="text" placeholder=" " v-model="search.filters.throttle.search">
              <span>Search</span>
            </div>
          </form>
        </template>

        <div class="showHideForm" 
          :class="{'arrowDown': !displayForm}"
          @click="displayForm = !displayForm"
        >
          {{displayForm ? 'HIDE' : 'SHOW'}}
        </div>
        <div class="transactions-table-container">
          <table class="transactions-table table">
            <thead>
              <!-- Query table head -->
              <tr 
              v-if="!searchSelected" 
              @click="handleQuerySort">
                <th v-for="item in tableColumns"
                  :key="item[0]" 
                  :data-sort="item[1]" 
                  :class="{'current asc': item[1] == query.sortField && query.sortOrder == 'asc', 
                          'current desc': item[1] == query.sortField && query.sortOrder == 'desc' }">
                  {{item[0]}}
                </th>
              </tr>

              <!-- Search table head -->
              <tr 
              v-else 
              @click="handleSearchSort">
                <th v-for="item in tableColumns"
                  :key="item[0]" 
                  :data-sort="item[1]" 
                  :class="{'current asc': item[1] == search.sortField && search.sortOrder == 'asc', 
                          'current desc': item[1] == search.sortField && search.sortOrder == 'desc' }">
                  {{item[0]}}
                </th>
              </tr>
            </thead>
            <tbody v-if="transactionsForTable.length" :class="{'search':searchSelected,'bigHeight':!displayForm}">
              <tr v-for="item in transactionsForTable" :key="item.id">
                <td>{{item.id}}</td>
                <td>{{moment(item.timestamp * 1000).utc().format('MM.DD.YYYY HH:mm:ss')}}</td>
                <td>{{item.direction}}</td>
                <td class="uppercase"> <cryptoicon :symbol="item.token" size="16" /> {{item.token}}</td>
                <td>{{item.blockchain}}</td>
                <td class="text-right">{{addCommas(item.amount)}}</td>
                <td class="text-right">${{addCommas(item.amount_usd)}}</td>
                <td class="text-right">${{addCommasDecimal(item.avg_price)}}</td>
                <td>{{item.from_owner}}</td>
                <td>{{item.to_owner}}</td>
      
                <td class="text-center">
                  <v-popover offset="0" placement="top" trigger="click">
                    <span class="separator"></span>
                    <template slot="popover">
                        <span>{{item.from_address}}</span>
                        <div class="copyAddress" @click="copyPopoverValue"></div>
                        <div class="closePopover" v-close-popover></div>
                    </template>
                  </v-popover>
                </td>
                
                <td class="text-center">
                  <v-popover offset="0" placement="top" trigger="click">
                    <span class="separator"></span>
                    <template slot="popover">
                        <span>{{item.to_address}}</span>
                        <div class="copyAddress" @click="copyPopoverValue"></div>
                        <div class="closePopover" v-close-popover></div>
                    </template>
                  </v-popover>
                </td>
                <td class="text-center">
                  <v-popover offset="0" placement="top" trigger="click">
                    <span class="separator"></span>
                    <template slot="popover">
                        <span>{{item.hash}}</span>
                        <div class="copyAddress" @click="copyPopoverValue"></div>
                        <div class="closePopover" v-close-popover></div>
                    </template>
                  </v-popover>
                </td>
              </tr>
            </tbody>
            <tbody v-else :class="{'search':searchSelected,'bigHeight':!displayForm}">
              <tr>
                <td colspan="14" class="text-center">No data, please check your filters</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination for query  -->
        <paginate
          v-if="!searchSelected"
          v-model="query.currentPage"
          :pageCount="query.pageAmount"
          :clickHandler="getQueryData"
          prevText='<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.928066 3.24063L4.63608 0.0756431C4.76156 -0.0140025 4.91737 0.000932952 5.03505 0.000932952C5.50575 0.000932952 5.50366 0.437028 5.50366 0.547511V7.10658C5.50366 7.19998 5.50572 7.65319 5.03505 7.65319C4.91737 7.65319 4.76153 7.66806 4.63608 7.57844L0.928093 4.32524C0.57971 4.07649 0.639907 3.78292 0.639907 3.78292C0.639907 3.78292 0.579682 3.48935 0.928066 3.24063Z" fill="#5371B3"/></svg>'
          nextText='<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.07193 3.24063L1.36392 0.0756431C1.23844 -0.0140025 1.08263 0.000932952 0.964953 0.000932952C0.49425 0.000932952 0.496338 0.437028 0.496338 0.547511V7.10658C0.496338 7.19998 0.494277 7.65319 0.964953 7.65319C1.08263 7.65319 1.23847 7.66806 1.36392 7.57844L5.07191 4.32524C5.42029 4.07649 5.36009 3.78292 5.36009 3.78292C5.36009 3.78292 5.42032 3.48935 5.07193 3.24063Z" fill="#5371B3"/></svg>'
          :containerClass="'pagination'">
        </paginate>

        <!-- Pagination for search  -->
        <paginate
          v-else
          v-model="search.currentPage"
          :pageCount="search.pageAmount"
          :clickHandler="getSearchData"
          prevText='<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.928066 3.24063L4.63608 0.0756431C4.76156 -0.0140025 4.91737 0.000932952 5.03505 0.000932952C5.50575 0.000932952 5.50366 0.437028 5.50366 0.547511V7.10658C5.50366 7.19998 5.50572 7.65319 5.03505 7.65319C4.91737 7.65319 4.76153 7.66806 4.63608 7.57844L0.928093 4.32524C0.57971 4.07649 0.639907 3.78292 0.639907 3.78292C0.639907 3.78292 0.579682 3.48935 0.928066 3.24063Z" fill="#5371B3"/></svg>'
          nextText='<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.07193 3.24063L1.36392 0.0756431C1.23844 -0.0140025 1.08263 0.000932952 0.964953 0.000932952C0.49425 0.000932952 0.496338 0.437028 0.496338 0.547511V7.10658C0.496338 7.19998 0.494277 7.65319 0.964953 7.65319C1.08263 7.65319 1.23847 7.66806 1.36392 7.57844L5.07191 4.32524C5.42029 4.07649 5.36009 3.78292 5.36009 3.78292C5.36009 3.78292 5.42032 3.48935 5.07193 3.24063Z" fill="#5371B3"/></svg>'
          :containerClass="'pagination'">
        </paginate>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import _ from 'lodash'

export default {
  name: 'Transactions',
  components: {
    Datepicker
  },
  data: () => ({
    loadingNow:false,
    renderingNow:false,
    displayForm:true,
    moreSelected:true,
    searchSelected:false,
    query:{
      filters:{
        immediate:{
          startDate: new Date().toUTCString(),
          endDate: new Date().toUTCString(),
          blockchain:'',
          token:'',
          direction:'',
          from_owner_type:'',
          to_owner_type:'',
        },
        throttle:{
          from_owner:'',
          to_owner:'',
          from_address:'',
          to_address:'',
          amount_usd:'',
        }
      },
      sortField:'timestamp',
      sortOrder:'desc',
      pageAmount:0,
      currentPage:1,
      responseHeaders:null
    },
    search:{
      filters:{
          immediate:{
            startDate: new Date().toUTCString(),
            endDate: new Date().toUTCString(),
          },
          throttle:{
            search:'',
          }
      },
      sortField:'timestamp',
      sortOrder:'desc',
      pageAmount:0,
      currentPage:1,
    },
    tableColumns:[
      ['ID','id'],
      ['Date (UTC)','timestamp'],
      ['Direction','direction'],
      ['Token','token'],
      ['Blockchain','blockchain'],
      ['Amount','amount'],
      ['Amount USD','amount_usd'],
      ['Price','avg_price'],
      ['From','from_owner'],
      ['To','to_owner'],
      ['FrAddr','from_address'],
      ['ToAddr','to_address'],
      ['Hash','hash'],
    ],
    NoSortingFields:['id','avg_price','from_address','to_address','hash'],
    queryTransactions:[],
    searchTransactions:[],
  }),
  watch: {
    // send immediate query
    queryFiltersImmediate: {
      handler(){
        this.getQueryData();
      },
     deep: true
    },
    // send query if user doesn't type 500ms
    queryFiltersThrottle: {
      handler: _.debounce(function(){
          this.getQueryData();
        }, 500),
     deep: true
    },

    // send immediate search
    searchFiltersImmediate: {
      handler(){
        this.getSearchData();
      },
     deep: true
    },
    // send search if user doesn't type 500ms
    searchFiltersThrottle: {
      handler: _.debounce(function(){
          this.getSearchData();
        }, 500),
     deep: true
    },
  },
  computed:{
    queryFiltersImmediate(){
      return this.query.filters.immediate;
    },
    queryFiltersThrottle(){
      return this.query.filters.throttle;
    },
    blockchainList(){
      return (this.query.responseHeaders && this.query.pageAmount != 0) ? this.query.responseHeaders.blockchains.split(', ').sort() : [];
    },
    tokenList(){
      return (this.query.responseHeaders && this.query.pageAmount != 0) ? this.query.responseHeaders.tokens.split(', ').sort().map(item => item.toUpperCase()) : [];
    },
    directionList(){
      return (this.query.responseHeaders && this.query.pageAmount != 0) ? this.query.responseHeaders.directions.split(', ').sort() : [];
    },
    fromTypeList(){
      return (this.query.responseHeaders && this.query.pageAmount != 0) ? this.query.responseHeaders.from_types.split(', ').sort() : [];
    },
    toTypeList(){
      return (this.query.responseHeaders && this.query.pageAmount != 0) ? this.query.responseHeaders.to_types.split(', ').sort() : [];
    },
    searchFiltersImmediate(){
      return this.search.filters.immediate;
    },
    searchFiltersThrottle(){
      return this.search.filters.throttle;
    },
    transactionsForTable(){
      return this.searchSelected ? this.searchTransactions : this.queryTransactions;
    }
  },
  methods:{
    copyPopoverValue(e){
      let closeBtn = e.target.parentNode.querySelector('.closePopover'); 
      this.copyToClipboard(e.target.parentNode.querySelector('span').textContent);
      e.target.parentNode.querySelector('span').textContent = 'Copied!';
      e.target.parentNode.querySelector('.copyAddress').style.display = 'none';
      setTimeout(() => {
        closeBtn.dispatchEvent(new Event('click'));
      },2000);
    },
    handleQuerySort(e){
      // SO SORTING fields
      if (this.NoSortingFields.includes(e.target.getAttribute('data-sort'))) return;
      this.query.sortField = e.target.getAttribute('data-sort');
      this.query.sortOrder = e.target.classList.contains('asc') ? 'desc' : 'asc';
      this.getQueryData();
    },

    handleSearchSort(e){
      // SO SORTING fields
      if (this.NoSortingFields.includes(e.target.getAttribute('data-sort'))) return;
      this.search.sortField = e.target.getAttribute('data-sort');
      this.search.sortOrder = e.target.classList.contains('asc') ? 'desc' : 'asc';
      this.getSearchData();
    },

    getQueryData(page = 1){
        let queryParameters = {
          params:{
            page:page
          }
        };
        // create object for IMMEDIATE query from filters
        for (const key in this.query.filters.immediate) {
          if (this.query.filters.immediate[key]){
            // add date formatting
            if (['startDate','endDate'].includes(key)){
              queryParameters.params[key] = moment(this.query.filters.immediate[key]).utc().format('YYYY-MM-DD');
            }
            // simple adding
            else{
              queryParameters.params[key] = this.query.filters.immediate[key].toLowerCase();
            }
          }
        }

        // create object for THROTTLE query from filters
        for (const key in this.query.filters.throttle) {
          if (this.query.filters.throttle[key]){

            // cancel query if field length < 3
            if (this.query.filters.throttle[key].length < 3) return;

            if (key == 'amount_usd'){
              // cancel query if amount_usd length < 6
              if (this.query.filters.throttle[key].length < 6) return;
              // more filter
              if (this.moreSelected){
                queryParameters.params[key] = this.query.filters.throttle[key];
              }
              // less filter
              else{
                queryParameters.params['less_than_amount_usd'] = this.query.filters.throttle[key];
              }
            }
            // use original values
            else if(['from_address','to_address'].includes(key)){
                    queryParameters.params[key] = this.query.filters.throttle[key].trim();
            }
            // simple adding
            else{
              queryParameters.params[key] = this.query.filters.throttle[key].toLowerCase();
            }
          }
        }

        // add sort fields
        queryParameters.params['sort_by'] = this.query.sortField;
        queryParameters.params['sort_order'] = this.query.sortOrder.toUpperCase();

        this.loadingNow = true;
        axios.get('tx/query',queryParameters).then(response => {
          this.query.currentPage = page;
          this.query.pageAmount = +response.headers['page-amount'];
          this.query.responseHeaders = response.headers;
          this.queryTransactions = response.data;

          this.renderingNow = true;
          this.loadingNow = false;
        });
    },
    getSearchData(page = 1){
        let queryParameters = {
          params:{
            page:page
          }
        };

        queryParameters.params['startDate'] =  moment(this.search.filters.immediate['startDate']).utc().format('YYYY-MM-DD');
        queryParameters.params['endDate'] =  moment(this.search.filters.immediate['endDate']).utc().format('YYYY-MM-DD');
        queryParameters.params['search'] = this.search.filters.throttle['search'].trim();

        // add sort fields
        queryParameters.params['sort_by'] = this.search.sortField;
        queryParameters.params['sort_order'] = this.search.sortOrder.toUpperCase();

        this.loadingNow = true;
        axios.get('tx/search',queryParameters).then(response => {
          this.search.currentPage = page;
          this.search.pageAmount = +response.headers['page-amount'];
          this.searchTransactions = response.data;

          this.renderingNow = true;
          this.loadingNow = false;
        });
    },
  },
  created(){
    this.getQueryData();
  },
  updated(){
    this.renderingNow = false;
  }
};
</script>
<style lang="scss">
.transactions-page{
  .row{
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    @media (max-width: 500px) {
        margin-bottom: 30px;
        h3{
          width: 100%;
        }
        .query-search-switcher{
          margin-left: -10px !important;
        }
    }
    
    .query-search-switcher{
        display: inline-flex;
        align-items: center;
        justify-content: space-evenly;
        width: 210px;
        margin-left: 10px;
        span{
          color:var(--font-color);
        }
        .switch-label{
              font-size: 13px;
              box-sizing: border-box;
              border-radius: 6px;
              padding: 3px 7px;
              border: 1px solid var(--header-br-color);
              cursor: pointer;
              transition: all .2s ease;
              &.active{
                border: 1px solid #593EFF;
              }
          }
        .toggle-switch-label {
            .switchmark {
                position: relative;
                display: inline-block;
                width: 40px;
                height: 2px;
                background-color: var(--input-br-color);
                border-radius: 12px;
                cursor: pointer;
                flex-shrink: 0;
                top: -4px;
                .switch-check {
                    position: absolute;
                    top: -9.2px;
                    left: 0px;
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    background-color: var(--button-active-bg-color);
                    border: 1px solid #7c6be9;
                    border-radius: 100%;
                    transition: all .2s ease;
                }
            }
            input {
                position: absolute;
                opacity: 0;
            }
        }
        .toggle-switch-label input:checked~.switchmark 
          .switch-check {
            left: 20px;
          }
    }
  }

  form{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 1230px;
    & > *{
      width: 168px !important;
      margin-bottom: 15px;
      &:nth-child(6n){
        min-width: 346px !important;
      }

      @media (max-width: 1500px) {
          width: 24% !important;
          &:nth-child(1){
            order: -2;
          }
          &:nth-child(7){
            order: -1;
          }
          &:nth-child(6n){
            min-width: auto !important;
          }
      }
      @media (max-width: 1000px) {
          width: 32% !important;
      }
      @media (max-width: 650px) {
          width: 49% !important;
      }
      @media (max-width: 500px) {
          width: 100% !important;
      }
    }
    &.searchForm{
      justify-content: flex-start;
      @media (max-width: 1000px) {
        justify-content: space-between;
      }

      & > *{
        margin-right: 8px;
        &:nth-child(3){
          min-width: 346px !important;
        }

        @media (max-width: 1000px) {
          width: 32% !important;
          margin-right: 0px;
          &:nth-child(3){
            min-width: auto !important;
          }
        }
        @media (max-width: 650px) {
            width: 49% !important;
            &:nth-child(3){
              min-width: 100% !important;
            }
        }
        @media (max-width: 500px) {
          width: 100% !important;
        }
      }
    }
  }

  .transactions-table-container{
    position: relative;
    @media (max-width: 1200px) {
        overflow-y: hidden;
        overflow-x: scroll;
    }
    .transactions-table{
        width: 100%;
        position: relative;
        min-width: 1200px;

        thead {
          display: table; 
          width: 100%;
        }
        tbody{
          display: block; 
          min-height: 270px;
          max-height: calc(100vh - 83px - 333px);
          overflow-y: scroll;
          &.search{
            max-height: calc(100vh - 83px - 276px);
          }
          &.bigHeight{
            max-height: calc(100vh - 83px - 216px);
          }
          tr {
            display: table;
            width: 100%;
          }
          td {
              svg{
                position: relative;
                top: -3px;
                vertical-align: bottom;
                margin-right: 3px;
              }
              .v-popover{
                display: inline-block;
                .separator{
                    background: var(--table-separator-link);
                    display: inline-block;
                    width: 25px;
                    height: 10px;
                    cursor: pointer;
                }
                &.open .separator{
                    background: var(--table-separator-link-active);
                }
              }
          }
        }
        th,td{
          max-width: 80px;
          &:nth-child(1){
            width: 7%;
          }
          &:nth-child(2){
            width: 11%;
          }
          &:nth-child(3){
            width: 8%;
          }
          &:nth-child(4){
            width: 7%;
          }
          &:nth-child(5){
            width: 8%;
          }
          &:nth-child(6){
            width: 7%;
          }
          &:nth-child(7){
            width: 9.5%;
          }
          &:nth-child(8){
            width: 7.5%;
            padding-right: 10px;
          }
          &:nth-child(9){
            width: 7%;
          }
          &:nth-child(10){
            width: 7%;
          }
          &:nth-child(11){
            width: 6%;
          }
          &:nth-child(12){
            width: 6%;
          }
          &:nth-child(13){
            width: 6%;
          }
        }
        td{
          &:nth-child(13){
            @media (min-width: 1200px) {
                width: 4.5%;
            }
          }
        }
      }
  }
  &.loading{
    pointer-events: none;
    table:before{
      content: "";
      width: 500%;
      height: 100%;
      position: absolute;
      z-index: 5;
      background: var(--loading-bg);
    }
    .transactions-table-container:after{
      content: "";
      width: 64px;
      height: 64px;
      background: url('../../assets/img/loader.svg') no-repeat;
      position: absolute;
      z-index: 10;
      left:50%;
      top:50%;
      transform: translate(-50%,-50%);
    }
  }
}
.tooltip {
    display: block !important;
    z-index: 10000;
    outline: 0;

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: black;
      z-index: 1;
    }

    &[x-placement^="top"] {
      margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="bottom"] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &.popover {
      $color: #7480a3;
      .popover-inner {
        background: $color;
        color: white;
        padding: 10px 15px;
        border-radius: 10px;
        box-shadow: 0 5px 30px rgba(black, .1);
      }

      .popover-arrow {
        border-color: $color;
      }

      .copyAddress{
        width: 16px;
        height: 16px;
        display: inline-block;
        background: url('../../assets/img/copy_white.svg') no-repeat;
        cursor: pointer;    
        margin-left: 10px;
        vertical-align: middle;
      }
      .closePopover{
        width: 16px;
        height: 16px;
        display: inline-block;
        background: url('../../assets/img/close_white.svg') no-repeat;
        cursor: pointer;
        margin-left: 10px;
        vertical-align: middle;
      }
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }
  }
</style>
